export const CREDENTIALS_FETCHING = 'CREDENTIALS_FETCHING';
export const CREDENTIALS_GET_SUCCESS = 'CREDENTIALS_GET_SUCCESS';
export const CREDENTIALS_GET_FAIL = 'CREDENTIALS_GET_FAIL';
export const SHOW_CREATE_EDIT_MODAL = 'SHOW_CREATE_EDIT_MODAL';
export const SET_ERROR_CREATE_CREDENTIAL = 'SET_ERROR_CREATE_CREDENTIAL';
export const SET_CREDENTIAL_FIELD = 'SET_CREDENTIAL_FIELD';
export const SAVE_CREDENTIAL_SUCCESS = 'SAVE_CREDENTIAL_SUCCESS';
export const SAVE_CREDENTIAL_FAIL = 'SAVE_CREDENTIAL_FAIL';
export const SHOW_CREDENTIAL_DETAIL = 'SHOW_CREDENTIAL_DETAIL';
export const CREDENTIAL_UPDATE_SUCCESS = 'CREDENTIAL_UPDATE_SUCCESS';
export const CREDENTIAL_UPDATE_FAIL = 'CREDENTIAL_UPDATE_FAIL';
export const SHOW_CONTEXT_MENU = 'SHOW_CONTEXT_MENU';
export const SHOW_CREDENTIAL_IMPORT = 'SHOW_CREDENTIAL_IMPORT';
export const CREDENTIALS_SET_FILES_TO_UPLOAD = 'CREDENTIALS_SET_FILES_TO_UPLOAD';
export const CREDENTIALS_SET_CSV_FILE_INDEX = 'CREDENTIALS_SET_CSV_FILE_INDEX';
export const CREDENTIALS_SET_UPLOAD_STATE = 'CREDENTIALS_SET_UPLOAD_STATE';
export const CREDENTIALS_RESET_FILE_STATE = 'CREDENTIALS_RESET_FILE_STATE';
export const CREDENTIALS_UPLOAD_CSV_UPDATE_PERCENT = 'CREDENTIALS_UPLOAD_CSV_UPDATE_PERCENT';
export const CREDENTIALS_SET_NAME_INTO_FILE_ERROR_LIST_CSV = 'CREDENTIALS_SET_NAME_INTO_FILE_ERROR_LIST_CSV';
export const CREDENTIALS_UPLOAD_CSV_ERROR = 'CREDENTIALS_UPLOAD_CSV_ERROR';
export const CREDENTIALS_CANCEL_REQUEST_UPLOAD_CSV = 'CREDENTIALS_CANCEL_REQUEST_UPLOAD_CSV';
export const CREDENTIALS_EXPORT_CSV_REQUEST = 'CREDENTIALS_EXPORT_CSV_REQUEST';
export const CREDENTIALS_EXPORT_CSV_SUCCESS = 'CREDENTIALS_EXPORT_CSV_SUCCESS';
export const CREDENTIALS_EXPORT_CSV_FAILURE = 'CREDENTIALS_EXPORT_CSV_FAILURE';
export const CREDENTIALS_CLEAR_ERROR = 'CREDENTIALS_CLEAR_ERROR';
export const INDIVIDUAL_SELECTION_CREDENTIALS = 'INDIVIDUAL_SELECTION_CREDENTIALS';
export const MULTIPLE_SELECTION_CREDENTIALS = 'MULTIPLE_SELECTION_CREDENTIALS';
export const CREDENTIALS_UNSELECTED = 'CREDENTIALS_UNSELECTED';
export const SET_AVAILABLE_VULNS = 'SET_AVAILABLE_VULNS';
export const CREDENTIALS_SET_BULK_UPDATE_FIELD = 'CREDENTIALS_SET_BULK_UPDATE_FIELD';
export const CREDENTIALS_SET_BULK_UPDATE_VALUE = 'CREDENTIALS_SET_BULK_UPDATE_VALUE';
export const CREDENTIALS_ADD_BULK_UPDATE_VALUE = 'CREDENTIALS_ADD_BULK_UPDATE_VALUE';
export const CREDENTIALS_REMOVE_BULK_UPDATE_VALUE = 'CREDENTIALS_REMOVE_BULK_UPDATE_VALUE';
export const CREDENTIALS_REFRESH_LIST = 'CREDENTIALS_REFRESH_LIST';
export const CREDENTIALS_SET_BULK_UPDATE_SUCCESS = 'CREDENTIALS_SET_BULK_UPDATE_SUCCESS';
export const CREDENTIALS_BULK_UPDATE_FINISHED = 'CREDENTIALS_BULK_UPDATE_FINISHED';
export const CREDENTIALS_ERROR = 'CREDENTIALS_ERROR';
export const CREDENTIALS_UNSELECT_ALL = 'CREDENTIALS_UNSELECT_ALL';
export const CREDENTIALS_SHOW_DELETE_CONFIRMATION = 'CREDENTIALS_SHOW_DELETE_CONFIRMATION';
export const SET_AVAILABLE_VULNS_FETCHING = 'SET_AVAILABLE_VULNS_FETCHING';
export const CREDENTIALS_SELECT_ALL = 'CREDENTIALS_SELECT_ALL';
export const FETCHING_CREDENTIAL = 'FETCHING_CREDENTIAL';
